import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ProcessCardRequestDTO,
  ProcessCardResponseDTO,
  ValidateOpenPayRequestDTO,
  ValidateOpenPayResponseDTO,
} from './PaymentOpenPayDTO';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class CardOpenpayService {
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  registerOpenPay(
    request: ProcessCardRequestDTO
  ): Observable<ProcessCardResponseDTO> {
    const uuid = uuidv4();
    const endpoint = environment.openpay_endpoint;
    const headers = new HttpHeaders({
      'x-transaction-ID': uuid, // Agrega UUID al headers
    });
    const httpOptions = { headers: headers };
    return this.http.post<ProcessCardResponseDTO>(
      `${environment.base_url}/${endpoint}`,
      request,
      httpOptions
    );
  }

  validateOpenPay(
    request: ValidateOpenPayRequestDTO
  ): Observable<ValidateOpenPayResponseDTO> {
    const endpoint = environment.openpay_validate_endpoint;
    const httpOptions = { headers: this.headers };
    return this.http.post<ValidateOpenPayResponseDTO>(
      `${environment.base_url}/${endpoint}`,
      request,
      httpOptions
    );
  }
}
